module.exports = "/_next/static/images/6cfd913bee75e48f03b190fb65406ea4-image-right-xs.jpg";